import { FormikProps } from 'formik'
import {
  Button,
  ButtonIcon,
  FormSelect,
  FormTextArea,
  IOption,
} from '../../../../../../../components'
import {
  IconPaths,
  IconSize,
  OptionsHelper,
  Receituario,
} from '../../../../../../../../_metronic/helpers'
import { FC } from 'react'
import { ResultFormIA } from './ResultadoIAModal'

export type Medicamento = {
  medicamento: string
  dosagem: string
  administracao: string
  quantidade: string
  posologia: string
  receituario?: IOption<Receituario>
  id?: number
}
type IReceitaIAModal = {
  onReset: () => void
  formik: FormikProps<ResultFormIA>
}

export const ReceitaIAModal: FC<IReceitaIAModal> = ({ onReset, formik }) => {
  const { values, setFieldValue } = formik

  return (
    <>
      <div className='d-flex align-items-stretch mb-1 w-100' style={{ gap: '0.5rem' }}>
        <div style={{ flex: 2 }} className='d-flex align-items-center'>
          <strong>Medicamento</strong>
        </div>
        <div style={{ flex: 2 }} className='d-flex align-items-center'>
          <strong>Dosagem</strong>
        </div>
        <div style={{ flex: 2 }} className='d-flex align-items-center'>
          <strong>Receituário</strong>
        </div>
        <div style={{ flex: 2 }} className='d-flex align-items-center'>
          <strong>Quantidade</strong>
        </div>
        <div style={{ flex: 3 }} className='d-flex align-items-center'>
          <strong>Posologia</strong>
        </div>
        <div style={{ width: '32px' }} />
      </div>
      {values.receita.map((_, index) => (
        <div
          key={index}
          className='d-flex align-items-stretch mb-3 w-100'
          style={{ gap: '0.5rem' }}
        >
          <div style={{ flex: 2 }}>
            <FormTextArea
              name={`receita.${index}.medicamento`}
              placeholder='Medicamento'
              formik={formik}
              rows={1}
              isDisabled={!!values.receita[index].id}
            />
          </div>

          <div style={{ flex: 2 }}>
            <FormTextArea
              name={`receita.${index}.dosagem`}
              placeholder='Dosagem'
              formik={formik}
              rows={1}
              isDisabled={!!values.receita[index].id}
            />
          </div>

          <div style={{ flex: 2 }}>
            <FormSelect
              name={`receita.${index}.receituario`}
              options={OptionsHelper.receituarios}
              inputId={`receita-${index}-receituario`}
              placeholder='Receituário'
              formik={formik}
              isClearable={false}
              isDisabled={!!values.receita[index].id}
            />
          </div>

          <div style={{ flex: 2 }}>
            <FormTextArea
              name={`receita.${index}.quantidade`}
              placeholder='Quantidade'
              formik={formik}
              rows={1}
            />
          </div>

          <div style={{ flex: 3 }}>
            <FormTextArea
              name={`receita.${index}.posologia`}
              placeholder='Posologia'
              formik={formik}
              rows={1}
            />
          </div>

          <div className='d-flex align-items-center justify-content-center'>
            <ButtonIcon
              color='var(--bs-gray-700)'
              icon={IconPaths.Trash}
              iconSize={IconSize.Small}
              className='m-0 p-0'
              onClick={() => {
                const updatedList = [...values.receita]
                updatedList.splice(index, 1)
                setFieldValue('receita', updatedList)
                onReset()
              }}
            />
          </div>
        </div>
      ))}
      <div className='d-flex justify-content-end'>
        <Button
          className='btn-sm btn-primary mt-3'
          icon={IconPaths.Add}
          onClick={() => {
            setFieldValue('receita', [
              ...values.receita,
              {
                medicamento: '',
                dosagem: '',
                receituario: undefined,
                quantidade: '',
                posologia: '',
              },
            ])
            onReset()
          }}
        >
          Adicionar Medicamento
        </Button>
      </div>
    </>
  )
}
